import { observable, action, computed, createTransformer, reaction } from "mobx";
import TarefaService from "../../../services/TarefaService";
import FluxoService from "../../../services/FluxoService";

export default class SolicitacoesAndamentoStore {

    @observable solicitacoesAndamentoLista;
    @observable loading;

    constructor() {
        this.solicitacoesAndamentoLista = [];

        this.tarefaService = new TarefaService();
        this.fluxoService = new FluxoService();
    }

    async carregarLista() {
        this.loading = true;
        this.solicitacoesAndamentoLista = [];

//        const promiseTarefas = this.tarefaService.listSolicitacoesEmAndamento()
//            .catch(err => {
//                console.error("Falha ao carregar solicitações em andamento por tarefa:", (err.response && err.response.data && err.response.data.message) || err.message);
//                return { data: [] }; // Retorna um objeto com 'data' vazio para não quebrar o Promise.all
//            });

        const promiseFluxo = this.fluxoService.listSolicitacoesEmAndamento()
            .catch(err => {
                console.error("Falha ao carregar solicitações em andamento por fluxo:", (err.response && err.response.data && err.response.data.message) || err.message);
                return { data: [] }; // Retorna um objeto com 'data' vazio para não quebrar o Promise.all
            });

        try {

  //          const [responseTarefas, responseFluxo] = await Promise.all([promiseTarefas, promiseFluxo]);
            const [responseFluxo] = await Promise.all([promiseFluxo]);
    
            //const listaTarefas = responseTarefas.data || [];
            const listaFluxo = responseFluxo.data || [];
    
//            const listaUnificada = [...listaTarefas, ...listaFluxo];
            const listaUnificada = [ ...listaFluxo];

            for(let row of listaUnificada) {
                row.idDetalhamento = row.idSolicitacaoEtt ? row.idSolicitacao + "/" + row.idSolicitacaoEtt : row.idSolicitacao;
            }

            // Ordena a lista pelo campo 'prazo' (data mais recente primeiro).
            listaUnificada.sort((a, b) => {
                // Itens sem prazo definido são movidos para o final da lista.
                if (a.prazo && !b.prazo) return -1; // a tem prazo, b não tem -> a vem primeiro
                if (!a.prazo && b.prazo) return 1;  // a não tem prazo, b tem -> b vem primeiro
                if (!a.prazo && !b.prazo) return 0; // nenhum tem prazo -> mantém a ordem

                // Ambos têm prazo, então converte 'DD/MM/YYYY' para um objeto Date e compara
                const dateA = new Date(a.prazo.split('/').reverse().join('-'));
                const dateB = new Date(b.prazo.split('/').reverse().join('-'));

                return dateB.getTime() - dateA.getTime();
            });

            this.solicitacoesAndamentoLista = listaUnificada;
        } catch (error) {
            //console.error("Ocorreu um erro inesperado ao processar as solicitações em andamento:", error);
        } finally {
            this.loading = false;
        }
    }

    fluxoFormatter(nomeFluxo){
        switch(nomeFluxo) {
            case "GloboMOTSolicitacaoMOT":
            case "SolicitacaoContratacao":
                nomeFluxo = "Solicitação de contratação";
                break;
            case "GloboMOTSolicitacaoEtt":
            case "SolicitacaoEtt":
                nomeFluxo = "Contratação";
                break;
            case "GloboMOTSolicitacaoTerminoAntecipado":
            case "SolicitacaoTerminoAntecipado":
                nomeFluxo = "Solicitação de termino Antecipado";
                break;
            case "GloboMOTSolicitacaoProrrogacao":
            case "SolicitacaoProrrogacao":
                nomeFluxo = "Solicitação de prorrogação";
                break;
        }
        return nomeFluxo;
    }

    setLista(value) {
        this.solicitacoesAndamentoLista = value;
    }
}